import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.profile-page {
  --profile-bg: #f2f6f4;
  --profile-surface: #ffffff;
  --profile-surface-soft: #f7faf8;
  --profile-surface-muted: #eef3f1;
  --profile-ink: #10211f;
  --profile-body: #334155;
  --profile-muted: #64748b;
  --profile-border: #dbe4e1;
  --profile-border-strong: #c7d3cf;
  --profile-primary: #0f766e;
  --profile-primary-hover: #0d9488;
  --profile-primary-dark: #115e59;
  --profile-primary-soft: #e8f7f4;
  --profile-focus: rgba(13, 148, 136, 0.22);
  min-height: 100%;
  background: var(--profile-bg);
  color: var(--profile-ink);
}

.profile-page,
.profile-page * {
  box-sizing: border-box;
}

.profile-page button,
.profile-page input {
  font: inherit;
}

.profile-shell {
  width: min(100%, 1180px);
  margin: 0 auto;
  padding: 26px 28px 40px;
}

.profile-heading {
  display: flex;
  min-height: 52px;
  align-items: center;
  gap: 13px;
  margin-bottom: 20px;
}

.profile-heading-icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cce3dd;
  border-radius: 10px;
  background: #e5f1ed;
  color: var(--profile-primary);
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.08);
}

.profile-heading-icon svg {
  width: 21px;
  height: 21px;
}

.profile-heading h1 {
  margin: 0;
  color: var(--profile-ink);
  font-size: 25px;
  line-height: 32px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.profile-workspace {
  display: grid;
  min-height: 620px;
  grid-template-columns: 300px minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid var(--profile-border);
  border-radius: 12px;
  background: var(--profile-surface);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.055), 0 1px 2px rgba(15, 23, 42, 0.03);
}

.identity-panel {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid rgba(15, 118, 110, 0.12);
  background: #e8f2ef;
  padding: 38px 30px 30px;
}

.identity-panel::after {
  content: "";
  position: absolute;
  right: -170px;
  bottom: -150px;
  width: 360px;
  height: 360px;
  border: 1px solid rgba(15, 118, 110, 0.09);
  border-radius: 999px;
  pointer-events: none;
}

.identity-profile,
.identity-meta,
.identity-note {
  position: relative;
  z-index: 1;
}

.identity-profile {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  flex-direction: column;
}

.profile-avatar {
  display: inline-flex;
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(15, 118, 110, 0.18);
  border-radius: 999px;
  background: #ffffff;
  color: var(--profile-primary);
  font-size: 24px;
  line-height: 1;
  font-weight: 800;
  box-shadow: 0 10px 28px rgba(15, 118, 110, 0.1);
}

.identity-copy {
  min-width: 0;
  margin-top: 24px;
}

.identity-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #64817b;
  font-size: 11px;
  line-height: 16px;
  font-weight: 750;
  letter-spacing: 0.06em;
}

.identity-copy h2 {
  overflow: hidden;
  margin: 0;
  color: #132925;
  font-size: 23px;
  line-height: 31px;
  font-weight: 800;
  letter-spacing: -0.025em;
  overflow-wrap: anywhere;
}

.role-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 7px;
  margin-top: 11px;
  border: 1px solid rgba(15, 118, 110, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  padding: 0 10px;
  color: var(--profile-primary-dark);
  font-size: 11px;
  line-height: 16px;
  font-weight: 750;
}

.role-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 999px;
  background: var(--profile-primary-hover);
}

.identity-meta {
  display: grid;
  gap: 12px;
  border-top: 1px solid rgba(15, 118, 110, 0.14);
  margin: 30px 0 0;
  padding-top: 24px;
}

.identity-meta-row {
  display: grid;
  gap: 4px;
  margin: 0;
}

.identity-meta dt {
  color: #6b837e;
  font-size: 11px;
  line-height: 16px;
  font-weight: 700;
}

.identity-meta dd {
  margin: 0;
  color: #26443e;
  font-size: 13px;
  line-height: 19px;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.identity-note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: auto;
  color: #56736d;
  font-size: 11px;
  line-height: 17px;
  font-weight: 600;
}

.identity-note-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  align-items: center;
  justify-content: center;
  color: var(--profile-primary);
}

.identity-note-icon svg {
  width: 16px;
  height: 16px;
}

.settings-panel {
  min-width: 0;
  padding: 34px 38px 36px;
}

.settings-section {
  min-width: 0;
}

.section-heading {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 11px;
}

.section-icon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d7e5e1;
  border-radius: 8px;
  background: var(--profile-surface-soft);
  color: var(--profile-primary);
}

.section-icon svg {
  width: 18px;
  height: 18px;
}

.section-heading h2 {
  margin: 0;
  color: var(--profile-ink);
  font-size: 17px;
  line-height: 24px;
  font-weight: 780;
  letter-spacing: -0.012em;
}

.password-rule {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  margin-left: auto;
  border: 1px solid #dce8e4;
  border-radius: 999px;
  background: var(--profile-surface-soft);
  padding: 0 9px;
  color: #60766f;
  font-size: 10px;
  line-height: 15px;
  font-weight: 700;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 17px 16px;
  margin-top: 22px;
}

.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.field-wide {
  grid-column: 1/-1;
}

.field-label {
  display: flex;
  min-height: 18px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--profile-body);
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
}

.field-label small {
  color: #7b8e88;
  font-size: 10px;
  font-weight: 650;
}

.field input {
  width: 100%;
  height: 46px;
  border: 1px solid #d3dedb;
  border-radius: 8px;
  background: #f8faf9;
  color: var(--profile-ink);
  font-size: 14px;
  line-height: 20px;
  outline: none;
  padding: 0 13px;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.field input:hover:not(:disabled) {
  border-color: #b8c8c3;
  background: #ffffff;
}

.field input:focus {
  border-color: var(--profile-primary);
  background: #ffffff;
  box-shadow: 0 0 0 3px var(--profile-focus);
}

.field input:disabled {
  cursor: not-allowed;
  border-color: #dfe7e4;
  background: var(--profile-surface-muted);
  color: #71827d;
  opacity: 1;
}

.field input::placeholder {
  color: #98aaa5;
}

.section-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e8eeeb;
  margin-top: 24px;
  padding-top: 18px;
}

.primary-button {
  display: inline-flex;
  min-width: 108px;
  height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: var(--profile-primary);
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  font-weight: 750;
  padding: 0 16px;
  box-shadow: 0 6px 16px rgba(15, 118, 110, 0.15);
  transition: background-color 140ms ease, box-shadow 140ms ease, transform 140ms ease;
}

.primary-button:hover:not(:disabled) {
  background: var(--profile-primary-hover);
  box-shadow: 0 8px 20px rgba(15, 118, 110, 0.2);
  transform: translateY(-1px);
}

.primary-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--profile-focus);
}

.primary-button:disabled {
  cursor: not-allowed;
  border-color: var(--profile-border);
  background: var(--profile-surface-muted);
  color: #94a3b8;
  box-shadow: none;
  transform: none;
}

.button-spinner {
  width: 16px;
  height: 16px;
  animation: profile-spin 700ms linear infinite;
}

.spinner-track {
  opacity: 0.25;
}

.spinner-head {
  opacity: 0.75;
}

.section-divider {
  height: 1px;
  background: var(--profile-border);
  margin: 30px 0;
}

.profile-loading {
  display: flex;
  min-height: 420px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: var(--profile-muted);
  font-size: 13px;
  font-weight: 650;
}

.profile-loader {
  width: 24px;
  height: 24px;
  border: 2px solid #d7e4e0;
  border-top-color: var(--profile-primary);
  border-radius: 999px;
  animation: profile-spin 700ms linear infinite;
}

@keyframes profile-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .profile-shell {
    padding: 22px 18px 32px;
  }
  .profile-workspace {
    min-height: 0;
    grid-template-columns: minmax(0, 1fr);
  }
  .identity-panel {
    min-height: 0;
    border-right: 0;
    border-bottom: 1px solid rgba(15, 118, 110, 0.12);
    padding: 26px;
  }
  .identity-panel::after {
    right: -110px;
    bottom: -230px;
    width: 330px;
    height: 330px;
  }
  .identity-profile {
    align-items: center;
    flex-direction: row;
    gap: 18px;
  }
  .profile-avatar {
    width: 64px;
    height: 64px;
    flex-basis: 64px;
    font-size: 21px;
  }
  .identity-copy {
    margin-top: 0;
  }
  .identity-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin-top: 22px;
    padding-top: 18px;
  }
  .identity-note {
    margin-top: 20px;
  }
  .settings-panel {
    padding: 30px;
  }
}
@media (max-width: 640px) {
  .profile-shell {
    padding: 18px 12px 28px;
  }
  .profile-heading {
    min-height: 46px;
    gap: 10px;
    margin-bottom: 14px;
  }
  .profile-heading-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 9px;
  }
  .profile-heading-icon svg {
    width: 19px;
    height: 19px;
  }
  .profile-heading h1 {
    font-size: 21px;
    line-height: 28px;
  }
  .profile-workspace {
    border-radius: 10px;
  }
  .identity-panel {
    padding: 22px 18px;
  }
  .identity-profile {
    gap: 14px;
  }
  .profile-avatar {
    width: 58px;
    height: 58px;
    flex-basis: 58px;
    font-size: 20px;
  }
  .identity-copy h2 {
    font-size: 19px;
    line-height: 26px;
  }
  .identity-eyebrow {
    margin-bottom: 2px;
  }
  .identity-meta {
    gap: 12px;
  }
  .settings-panel {
    padding: 24px 16px 26px;
  }
  .section-heading {
    gap: 9px;
  }
  .section-heading h2 {
    font-size: 16px;
  }
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 15px;
    margin-top: 20px;
  }
  .field-wide {
    grid-column: auto;
  }
  .field input {
    height: 48px;
    font-size: 16px;
  }
  .section-actions {
    margin-top: 22px;
    padding-top: 16px;
  }
  .primary-button {
    width: 100%;
    min-width: 0;
    height: 48px;
  }
  .section-divider {
    margin: 26px 0;
  }
}
@media (max-width: 380px) {
  .identity-meta {
    grid-template-columns: minmax(0, 1fr);
  }
  .password-rule {
    margin-left: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .button-spinner,
  .profile-loader {
    animation: none !important;
  }
  .profile-page *,
  .profile-page *::before,
  .profile-page *::after {
    transition-duration: 0.01ms !important;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
        }
        await this.service.render();
    }

    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success("프로필이 업데이트되었습니다.");
        } else {
            await this.service.modal.error(data || "업데이트에 실패했습니다.");
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password) {
            await this.service.modal.error("새 비밀번호를 입력해주세요.");
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call("change_password", {
            current_password: current_password,
            new_password: new_password
        });

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success("비밀번호가 변경되었습니다.");
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.modal.error(data || "비밀번호 변경에 실패했습니다.");
        }
        await this.service.render();
    }
}

export default PageMypageComponent;